/**
 * DisplaySettings — Page dédiée "Écrans agence" pour la gestion des tokens
 * d'affichage partagé (TV showroom). Réservée aux propriétaires/administrateurs.
 */
import DisplayTokensManager from "@/components/agency/DisplayTokensManager";
import { Link } from "react-router-dom";
import { ArrowLeft, Monitor, ExternalLink } from "lucide-react";

const DisplaySettings = () => {
  const openScreenPreview = () => {
    window.open("/app/command-center/screen", "_blank", "noopener");
  };

  return (
    <div className="wyvio-fade-in" data-testid="page-display-settings">
      <div className="flex items-center justify-between mb-6">
        <Link
          to="/app/parametres"
          className="inline-flex items-center gap-1.5 text-[13px] font-medium text-[#6B7280] hover:text-[#111]"
        >
          <ArrowLeft size={15} strokeWidth={2} /> Paramètres
        </Link>
        <button
          type="button"
          data-testid="display-settings-preview"
          onClick={openScreenPreview}
          className="h-9 inline-flex items-center gap-1.5 rounded-full bg-white border border-[#EEF2F5] px-3.5 text-[12px] font-medium text-[#111] hover:bg-[#F7F8FA]"
        >
          <ExternalLink size={13} strokeWidth={2} />
          Prévisualiser l&apos;écran
        </button>
      </div>

      <div className="mb-8">
        <div className="flex items-center gap-3">
          <div className="h-11 w-11 rounded-2xl bg-[#111] text-[#C8FF2F] flex items-center justify-center">
            <Monitor size={18} strokeWidth={2} />
          </div>
          <div>
            <h1 className="text-[26px] font-semibold tracking-tight text-[#111]">
              Écrans agence
            </h1>
            <p className="mt-1 text-[13px] text-[#6B7280]">
              Générez un lien sécurisé pour un TV/écran partagé. Lecture seule.
              Aucune donnée client sensible n&apos;est affichée.
            </p>
          </div>
        </div>
      </div>

      <DisplayTokensManager />
    </div>
  );
};

export default DisplaySettings;
